import { SectionColumnConfigKey } from '../../../../../../../../../models/enum/shared/section-column-config-key';
import { SectionColumnConfigProductInfoKey } from '../../../../../../../../../models/enum/shared/section-column-config-product-info-key';
import { SectionColumnConfig } from '../../../../../../../../../models/menu/section/section-column-config';
import { SectionColumnConfigState } from '../../../../../../../../../models/enum/shared/section-column-config-state';

export class FixedLocationPropertyViewModel {
  constructor(
    public key: SectionColumnConfigProductInfoKey,
    public columnConfig: SectionColumnConfig
  ) {}

  static hasColumnType(data: FixedLocationPropertyViewModel[] | null, key: SectionColumnConfigProductInfoKey): boolean {
    return data?.some(item => item?.key === key) ?? false;
  }

  static buildFixedLocationProperty(
    configs: Map<SectionColumnConfigKey, SectionColumnConfig | null>
  ): FixedLocationPropertyViewModel[] {
    return Object.values(SectionColumnConfigProductInfoKey)
      .map(key => {
        const config = configs?.get(key);
        const state = config?.defaultState;
        const isEnabled: boolean = state === SectionColumnConfigState.On || state === SectionColumnConfigState.Auto;
        return config?.isFixedLocation === true && isEnabled ? new FixedLocationPropertyViewModel(key, config) : null;
      })
      .filter((config): config is FixedLocationPropertyViewModel => config !== null);
  }

  isBadgeProperty(): boolean {
    return this.key === SectionColumnConfigProductInfoKey.Badges;
  }
}
